import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './EYDiscountSurchargeTable.metadata.json5';
import './EYDiscountSurchargeTable.messages';

const getCell = (items, index, property) => {
    //  console.log('items: ', items[property.id])
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

export function EYDiscountSurchargeTable({ data }) {
    const overrides = {
        eyDiscountSurchargeTable: {
            data: data
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCell: getCell
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

EYDiscountSurchargeTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

EYDiscountSurchargeTable.defaultProps = {
    data: []
};


export default EYDiscountSurchargeTable;
